jQuery("#telefone")
        .mask("(99) 9999-99999")
        .focusout(function (event) {  
            var target, phone, element;  
            target = (event.currentTarget) ? event.currentTarget : event.srcElement;  
            phone = target.value.replace(/\D/g, '');
            element = jQuery(target);  
            element.unmask();  
            if(phone.length > 10) {  
                element.mask("(99) 99999-99999");  
            } else {  
                element.mask("(99) 9999-999999");  
            }  
        });